import React from "react";
import { Route } from "react-router-dom";
import { Cnt_Reports, Cnt_Reports_Page, Cnt_MainSearch } from "containers";

export default (caseNo: number) => {
  return [
    <Route key="reports" path="/" element={<Cnt_Reports />} />,
    <Route
      key="reporting-page"
      path="/reporting-page"
      element={<Cnt_Reports_Page />}
    />,
    <Route key="search" path="/search" element={<Cnt_MainSearch />} />,
  ];
};
